import React from 'react';
import { Breadcrumb, Radio, Input, Button, InputNumber, Modal } from '@roo/roo';
import { getCookie } from '@utiljs/cookie';
import { connect } from 'react-redux';
import Region from '@/components/Region/index2';
import request from '@/utils/request';
import utils from '@/utils/utils';
import regionUtil from '@/utils/region';
import './addFreight.scss';

// @ts-ignore
const RadioGroup = Radio.Group;

interface IState {
    provinceMapArr: any[];
    provinceList: urls.freight.IprovinceInfo[];
    paySelectProvinceList: urls.freight.IprovinceInfo[];
    payAreaList: {
        calulateFeeMethod: {
            baseUnit: number;
            baseFee: number;
            stepUnit: number;
            stepFee: number;
        };
        payCities: urls.freight.Icity[];
    }[];
    freeCities: urls.freight.Icity[];
    noServiceCities: urls.freight.Icity[];
    billType: number;
    templateName: string;
    providerId: string;
    templateId: number | string;
    allCities: urls.freight.Icity[];
    selectCityVisible: boolean;
    submitModalVisible: boolean;
    selectCityIndex: number;
    isEdit: boolean;
}

interface IProps {
    history: any;
    editData: any;
}

class AddFreight extends React.Component<IProps, IState> {
    selectCityRef: any;

    constructor(props: IProps) {
        super(props);
        const urlObj: any = utils.urlParse();
        this.state = {
            provinceMapArr: [], // 方便比较用，如：[{groupName: 'ABC', cityId: [2,3,4]}]
            provinceList: [], // 全部省份列表
            paySelectProvinceList: [], // 付费区域可选择的省份列表
            payAreaList: [], // 付费区域信息
            freeCities: [], // 包邮区域
            noServiceCities: [], // 不支持区域
            billType: 1, // 运费模板计费方式: 1按件 2按重量; 【一个模版只能有一种计费方式】
            providerId: getCookie('serviceProviderID'), // 服务商ID
            templateName: '', // 模板名称
            templateId: urlObj.templateId || 0, // 模板ID,新增0
            isEdit: !!urlObj.templateId,
            allCities: [],
            selectCityVisible: false,
            selectCityIndex: 0, // 操作的第几个邮费区域
            submitModalVisible: false,
        };
    }

    async componentDidMount() {
        const { state, props } = this;
        const editData = props.editData || {};
        // console.log(editData);

        const data = await request.get('/api/city/provinceGroup');
        const allCities: any = [];
        const provinceMapArr: any = [];
        data.data.forEach((item: any) => {
            const cityIds: string[] = [];
            item.cityList.forEach((city: any) => {
                allCities.push(city);
                cityIds.push(city.cityId);
            });
            provinceMapArr.push({
                groupName: item.groupName,
                cityIds,
            });
        });

        if (state.isEdit) {
            if (!editData || !editData.billType) {
                return;
            }
            this.setState(
                {
                    ...editData,
                    provinceList: data.data,
                    allCities,
                    provinceMapArr,
                },
                () => {
                    this.setState({
                        paySelectProvinceList: this.getProvinceFromCity(editData.noServiceCities),
                    });
                },
            );
        } else {
            this.setState({
                provinceList: data.data,
                freeCities: allCities,
                allCities,
                provinceMapArr,
            });
        }
    }

    getItems = () => {
        const { isEdit } = this.state;
        return [
            {
                text: '运费模板',
                onClick: () => {
                    this.props.history.push('/freight/list?type=1');
                },
            },
            {
                text: `${isEdit ? '编辑' : '新建'}运费模板`,
            },
        ];
    };

    // items = [{
    //     text: '运费模板',
    //     onClick: () => {
    //         this.props.history.push('/freight/list?type=1');
    //     },
    // }, {
    //     text: '新建运费模板',
    // }];

    handleTemplateName = (e: any) => {
        this.setState({
            templateName: e.target.value,
        });
    };

    // 包邮区域城市变化，此时需要跟无法配送区域联动
    handleCityChange = (cities: any) => {
        const { state } = this;
        // 所有区域 减去 包邮区域，减去 付费区域，剩下就是无法配送区域
        const freeCities = cities;
        const noServiceCities = regionUtil.getTargetCities(
            state.allCities,
            freeCities,
            this.getPayCities(),
        );
        // 包邮区域可选择的地区，其实就是无法配送的地区
        this.setState({
            freeCities,
            noServiceCities,
            paySelectProvinceList: this.getProvinceFromCity(noServiceCities),
        });
    };

    // 获取新的province结构，带groupName的
    getProvinceFromCity = (cities: urls.freight.Icity[]) => {
        const { state } = this;
        const province: any = [];
        const provinceMap: any = {}; // 先整成对象，再转为数组，觉得有点麻烦
        cities.forEach(city => {
            for (let i = 0; i < state.provinceMapArr.length; i++) {
                const item = state.provinceMapArr[i];
                if (item.cityIds.indexOf(city.cityId) !== -1) {
                    if (!provinceMap[item.groupName]) {
                        provinceMap[item.groupName] = [];
                    }
                    provinceMap[item.groupName].push(city);
                    break;
                }
            }
        });

        /* eslint-disable */
        for (const groupName in provinceMap) {
            province.push({
                groupName,
                cityList: provinceMap[groupName],
            });
        }
        /* eslint-enable */
        return province;
    };

    getPayCities = (payAreaList?: any) => {
        const { state } = this;
        let cities: any = [];
        (payAreaList || state.payAreaList).forEach((item: any) => {
            cities = cities.concat(item.payCities);
        });
        return cities;
    };

    // 渲染区域文案
    renderRegionText = (cities: urls.freight.Icity[]) => {
        const regionTextDom: any = [];
        cities.forEach((city, index) => {
            regionTextDom.push(<span key={index}>{city.cityName}</span>);
        });
        return regionTextDom.length > 0 ? regionTextDom : <span>无</span>;
    };

    // 增加付费区域-城市选择确定
    handleSelectPayCity = () => {
        const { state } = this;
        const cities = this.selectCityRef.getSelectedCities();
        if (!cities || cities.length === 0) {
            this.setState({
                selectCityVisible: false,
            });
            return;
        }
        const payAreaList = utils.simpleCopy(state.payAreaList);
        const selectPayArea = payAreaList[state.selectCityIndex];

        if (selectPayArea) {
            selectPayArea.payCities = cities;
        } else {
            payAreaList[state.selectCityIndex] = {
                calulateFeeMethod: {
                    baseUnit: undefined,
                    baseFee: undefined,
                    stepUnit: undefined,
                    stepFee: undefined,
                },
                payCities: cities,
            };
        }

        // 同时需要更新无法配送区域数据
        const noServiceCities = regionUtil.getTargetCities(
            state.allCities,
            state.freeCities,
            this.getPayCities(payAreaList),
        );
        // 再次增加付费区域时，去掉选中的这些城市
        const paySelectProvinceList = this.getProvinceFromCity(noServiceCities);

        this.setState({
            payAreaList,
            noServiceCities,
            paySelectProvinceList,
            selectCityVisible: false,
        });
    };

    // 删除付费区域
    deleteRegion = (index: number) => {
        const { state } = this;
        Modal.confirm({
            title: '',
            children: '确认删除吗？',
            size: 'sm',
            onConfirm: () => {
                const payAreaList = utils.simpleCopy(state.payAreaList);
                payAreaList.splice(index, 1);
                // 同时更新无法配送区域
                const noServiceCities = regionUtil.getTargetCities(
                    state.allCities,
                    state.freeCities,
                    this.getPayCities(payAreaList),
                );
                this.setState({
                    payAreaList,
                    noServiceCities,
                    paySelectProvinceList: this.getProvinceFromCity(noServiceCities),
                });
            },
        });
    };

    // 运费相关信息变更
    handleFeeChange = (index: number, val: any, key: string) => {
        const { state } = this;
        const payAreaList = utils.simpleCopy(state.payAreaList);
        payAreaList[index].calulateFeeMethod[key] = val;
        this.setState({
            payAreaList,
        });
    };

    handleSubmitModal = () => {
        const { state } = this;
        // 校验
        if (!state.templateName.trim()) {
            utils.toast('warn', '请填写模板名称');
            return;
        }
        let valid = true;
        /* eslint-disable */
        state.payAreaList.forEach((item: any) => {
            for (const key of Object.keys(item.calulateFeeMethod)) {
                if (!item.calulateFeeMethod[key]) {
                    valid = false;
                    break;
                }
            }
        });
        /* eslint-enable */
        if (!valid) {
            utils.toast('warn', '请填写完整付费信息');
            return;
        }
        this.setState({
            submitModalVisible: true,
        });
    };

    // 最后提交操作
    handleSubmit = async () => {
        const { state, props } = this;
        const params = {
            providerId: state.providerId,
            templateId: state.templateId,
            templateName: state.templateName.trim(),
            billType: state.billType,
            payAreaList: state.payAreaList,
            freeCities: state.freeCities,
            noServiceCities: state.noServiceCities,
        };
        const res = await request.post('/api/carriageTemplates/addOrUpdate', params, {
            headers: {
                'Content-Type': 'application/json',
            },
        });
        if (res.code === 0) {
            props.history.push('/freight/list?type=1');
        }
    };

    getCityText = (cities: any = []) => {
        const { length } = cities;
        if (length === 0) {
            return '无';
        }
        return `${cities.map((city: any) => city.cityName).join('、')}等${length}个`;
    };

    render() {
        const { state } = this;
        const inputNumberProps = {
            showOperator: false,
            isForceToZeroWhenEmpty: false,
            min: 1,
            max: 999,
        };

        return (
            <div className="add-freight">
                <Breadcrumb type="oblique" items={this.getItems()} />
                <div className="title20" style={{ marginBottom: 34 }}>
                    {`${state.isEdit ? '编辑' : '新建'}运费模版`}
                </div>
                {/* 模板基础信息 */}
                <div className="freight-block">
                    <div className="title16">模板基础信息</div>
                    <div className="freight-block__content">
                        <div className="flex-vertical-center">
                            <div className="freight-block__label">模板名称</div>
                            <Input
                                style={{ width: 350 }}
                                value={state.templateName}
                                onChange={this.handleTemplateName}
                                maxLength={20}
                            />
                        </div>
                    </div>
                </div>
                {/* 包邮配送区域 */}
                <div className="freight-block">
                    <div className="title16">包邮配送区域</div>
                    <div className="freight-block__content">
                        <Region
                            bgStyle="#F9FAFB"
                            // @ts-ignore
                            changeValue={this.handleCityChange}
                            provinceList={state.provinceList}
                            // @ts-ignore
                            selectedCity={state.freeCities}
                            disabledCity={this.getPayCities()}
                        />
                    </div>
                </div>
                {/* 买家付邮费区域 */}
                <div className="freight-block">
                    <div className="title16">买家付邮费区域</div>
                    <div className="freight-block__content">
                        <div className="flex-vertical-center mgb20">
                            <div className="freight-block__label">计费方式</div>
                            <RadioGroup
                                value={state.billType}
                                disabled={state.isEdit}
                                onChange={(val: number) => {
                                    // 切换type后，清空计费方式
                                    const payAreaList = utils.simpleCopy(state.payAreaList);
                                    payAreaList.forEach((item: any) => {
                                        item.calulateFeeMethod = {
                                            baseUnit: undefined,
                                            baseFee: undefined,
                                            stepUnit: undefined,
                                            stepFee: undefined,
                                        };
                                    });
                                    this.setState({
                                        billType: val,
                                        payAreaList,
                                    });
                                }}
                            >
                                <Radio value={1}>按件计费</Radio>
                                <Radio value={2}>按重量计费</Radio>
                            </RadioGroup>
                        </div>
                        {state.payAreaList.map((item, index) => {
                            const { calulateFeeMethod, payCities } = item;
                            const isKg = state.billType === 2;
                            const unit = isKg ? 'kg' : '件';
                            return (
                                <div className="region-block" key={index}>
                                    <div className="flex mgb20">
                                        <div className="region-block__label">地区：</div>
                                        <div className="region-block__city">
                                            {this.renderRegionText(payCities)}
                                        </div>
                                    </div>
                                    <div className="flex-vertical-center mgt20">
                                        <div className="flex-vertical-center rigion-block__first-input">
                                            <InputNumber
                                                {...inputNumberProps}
                                                value={calulateFeeMethod.baseUnit}
                                                onChange={val => {
                                                    this.handleFeeChange(index, val, 'baseUnit');
                                                }}
                                                precision={isKg ? 2 : 0}
                                            />
                                            <span className="region-block__unit">{`${unit}内`}</span>
                                            <InputNumber
                                                {...inputNumberProps}
                                                value={calulateFeeMethod.baseFee}
                                                onChange={val => {
                                                    this.handleFeeChange(index, val, 'baseFee');
                                                }}
                                                precision={2}
                                            />
                                            <span className="region-block__unit">元</span>
                                        </div>
                                        <div className="flex-vertical-center">
                                            <span className="region-block__unit">每增加</span>
                                            <InputNumber
                                                {...inputNumberProps}
                                                value={calulateFeeMethod.stepUnit}
                                                onChange={val => {
                                                    this.handleFeeChange(index, val, 'stepUnit');
                                                }}
                                                precision={isKg ? 2 : 0}
                                            />
                                            <span className="region-block__unit">{`${unit}，增加运费`}</span>
                                            <InputNumber
                                                {...inputNumberProps}
                                                value={calulateFeeMethod.stepFee}
                                                onChange={val => {
                                                    this.handleFeeChange(index, val, 'stepFee');
                                                }}
                                                precision={2}
                                            />
                                            <span className="region-block__unit">元</span>
                                        </div>
                                    </div>
                                    <div
                                        className="absolute region-del"
                                        onClick={this.deleteRegion.bind(this, index)}
                                    >
                                        <a>删除</a>
                                    </div>
                                </div>
                            );
                        })}
                        <Button
                            className="mgt20 mgl20"
                            onClick={() => {
                                this.setState({
                                    selectCityVisible: true,
                                    selectCityIndex: state.payAreaList.length,
                                });
                            }}
                        >
                            添加付邮费区域
                        </Button>
                    </div>
                </div>
                {/* 无法配送区域 */}
                <div className="freight-block">
                    <div className="title16">无法配送区域</div>
                    <div className="freight-block__content">
                        <div className="region-block">
                            <div className="flex">
                                <div className="region-block__label">地区：</div>
                                <div className="region-block__city">
                                    {this.renderRegionText(state.noServiceCities)}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="freight-block">
                    <Button
                        type="hollow"
                        onClick={() => {
                            this.props.history.push('/freight/list?type=1');
                        }}
                    >
                        取消
                    </Button>
                    <Button style={{ marginLeft: 10 }} onClick={this.handleSubmitModal}>
                        确定
                    </Button>
                </div>
                {/* 选择区域弹框 */}
                <Modal
                    visible={state.selectCityVisible}
                    backdropClosable={false}
                    title="请选择地区"
                    size="lg"
                    onCancel={() => {
                        this.setState({
                            selectCityVisible: false,
                        });
                    }}
                    onConfirm={this.handleSelectPayCity}
                >
                    <Region
                        controlled={false}
                        haveCheckAll={false}
                        ref={(ref: any) => {
                            this.selectCityRef = ref;
                        }}
                        provinceList={state.paySelectProvinceList}
                    />
                </Modal>
                {/* 提交二次确认弹框 */}
                <Modal
                    visible={state.submitModalVisible}
                    backdropClosable={false}
                    title="请确认以下信息"
                    style={{ width: 520 }}
                    onCancel={() => {
                        this.setState({
                            submitModalVisible: false,
                        });
                    }}
                    onConfirm={this.handleSubmit}
                >
                    <div className="submit-modal-content">
                        <div className="flex submit-block">
                            <div className="submit-label">包邮配送区域：</div>
                            <div className="submit-content">
                                {this.getCityText(state.freeCities)}
                            </div>
                        </div>
                        <div className="flex submit-block">
                            <div className="submit-label">买家付邮费区域：</div>
                            <div className="submit-content">
                                {this.getCityText(this.getPayCities())}
                            </div>
                        </div>
                        <div className="flex submit-block">
                            <div className="submit-label">无法配送区域：</div>
                            <div className="submit-content">
                                {this.getCityText(state.noServiceCities)}
                            </div>
                        </div>
                    </div>
                </Modal>
            </div>
        );
    }
}

function mapStateToProps(state: any) {
    const { freight } = state;
    return {
        ...freight,
    };
}

export default connect(mapStateToProps)(AddFreight);
